import { render, staticRenderFns } from "./ContactHelpDesk.vue?vue&type=template&id=740c55f2&"
import script from "./ContactHelpDesk.vue?vue&type=script&lang=js&"
export * from "./ContactHelpDesk.vue?vue&type=script&lang=js&"
import style0 from "./ContactHelpDesk.vue?vue&type=style&index=0&id=740c55f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports